module.exports = __webpack_public_path__ + "img/crowd-old.7613554.png";